"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StakingReport = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const material_1 = require("@mui/material");
const icons_material_1 = require("@mui/icons-material");
const x_data_grid_1 = require("@mui/x-data-grid");
const react_intl_1 = require("react-intl");
const mui_page_layout_1 = require("@dzambalaorg/mui-page-layout");
const react_hooks_1 = require("@dzambalaorg/react-hooks");
const exchange_1 = require("@framework/exchange");
const provider_user_1 = require("@dzambalaorg/provider-user");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const schemas_1 = require("./schemas");
const search_1 = require("./search");
const STAKING_REPORT_URL = "/staking/report";
const StakingReport = (props) => {
    const { service } = props;
    const { profile } = (0, provider_user_1.useUser)();
    const initialSearchValues = (0, react_1.useMemo)(() => {
        return (0, schemas_1.stakingReportSearchValuesCreator)(profile)[service];
    }, [service, profile]);
    const { isLoading, take, skip, onChangePage, allRows, totalCount } = (0, react_hooks_1.useFetchQuery)(STAKING_REPORT_URL, void 0, void 0, initialSearchValues);
    const { formatMessage } = (0, react_intl_1.useIntl)();
    // TODO - [AFTER ALL REFACTORING] - check possibility to return search values from useFetchQuery
    // const { fn } = useApiCall(async (api, values) => {
    //   return api.fetchFile({
    //     url: "/staking/report/export",
    //     data: values,
    //   });
    // });
    const handleExport = () => {
        // return fn(void 0, search);
        return Promise.resolve();
    };
    // prettier-ignore
    const columns = (0, schemas_1.stakingReportColumnsCreator)(formatMessage);
    return ((0, jsx_runtime_1.jsxs)(material_1.Grid, { children: [(0, jsx_runtime_1.jsx)(mui_page_layout_1.Breadcrumbs, { path: ["dashboard", "staking", "staking.report"] }), (0, jsx_runtime_1.jsx)(mui_page_layout_1.PageHeader, { message: "pages.staking.report.title", children: (0, jsx_runtime_1.jsx)(ui_kit_1.Button, { startIcon: (0, jsx_runtime_1.jsx)(icons_material_1.CloudDownload, {}), onClick: handleExport, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "form.buttons.export" }) }) }), (0, jsx_runtime_1.jsx)(search_1.StakingReportSearchForm, { initialSearchValues: initialSearchValues, service: service }), (0, jsx_runtime_1.jsx)(x_data_grid_1.DataGrid, { pagination: true, paginationMode: "server", rowCount: totalCount, paginationModel: { page: skip / take, pageSize: take }, onPaginationModelChange: ({ page }) => onChangePage({}, page), pageSizeOptions: [5, 10, 25], loading: isLoading, columns: columns, rows: allRows.map((stake) => ({
                    id: stake.id,
                    account: stake.account,
                    deposit: (0, exchange_1.formatItem)(stake.stakingRule?.deposit),
                    stakingRule: stake.stakingRule?.title,
                    createdAt: stake.createdAt,
                })) })] }));
};
exports.StakingReport = StakingReport;
//# sourceMappingURL=index.js.map